export type Lang = 'vi' | 'en'

const messages = {
  vi: {
    'header.tab.request': 'Đề xuất',
    'header.tab.feedback': 'Góp ý',
    'header.tab.community': 'Cộng đồng',

    'request.title': 'Đề xuất khoá học mới',
    'request.subtitle': 'Có module hoặc khoá học bạn muốn Claudemy thêm vào? Gửi đề xuất bên dưới.',
    'request.field.kind': 'Loại đề xuất',
    'request.field.title': 'Tiêu đề',
    'request.field.title.help': '3–120 ký tự, mô tả ngắn gọn',
    'request.field.description': 'Lý do đề xuất',
    'request.field.description.help': 'Bạn muốn học gì? Cho ai? Tại sao quan trọng?',
    'request.field.email': 'Email (không bắt buộc)',
    'request.field.email.help': 'Để chúng tôi báo lại khi có cập nhật',
    'request.kind.module': 'Module (chương trong một khoá)',
    'request.kind.course': 'Khoá học hoàn chỉnh',
    'request.submit': 'Gửi đề xuất',
    'request.submit.loading': 'Đang gửi...',

    'feedback.title': 'Góp ý / Báo lỗi',
    'feedback.subtitle': 'Cảm ơn bạn đã giúp Claudemy tốt hơn.',
    'feedback.context': 'Đang góp ý cho:',
    'feedback.field.message': 'Nội dung góp ý',
    'feedback.field.message.help': 'Sai chính tả, bug, đề xuất cải thiện... mô tả càng cụ thể càng tốt',
    'feedback.field.email': 'Email (không bắt buộc)',
    'feedback.field.email.help': 'Để báo lại khi đã xử lý',
    'feedback.submit': 'Gửi góp ý',
    'feedback.submit.loading': 'Đang gửi...',

    'success.title': 'Cảm ơn bạn!',
    'success.body.request': 'Đề xuất đã ghi nhận. Đội ngũ sẽ xem xét và phản hồi qua issue trên GitHub.',
    'success.body.feedback': 'Góp ý đã ghi nhận. Đội ngũ sẽ xem xét sớm.',
    'success.viewIssue': 'Xem issue',
    'success.again': 'Gửi cái khác',

    'error.email_required_check': 'Email không hợp lệ',
    'error.turnstile': 'Vui lòng xác minh không phải bot, thử lại.',
    'error.rate_limited': 'Bạn đã gửi quá nhiều, thử lại sau 1 giờ.',
    'error.invalid_input': 'Dữ liệu không hợp lệ. Kiểm tra lại các trường.',
    'error.network': 'Lỗi mạng, kiểm tra kết nối và thử lại.',
    'error.internal': 'Lỗi hệ thống, thử lại sau.',
    'error.turnstile_pending': 'Vui lòng hoàn thành xác minh trước khi gửi.',

    'min': 'Ít nhất {n} ký tự',
    'max': 'Tối đa {n} ký tự',

    'requests.title': 'Đề xuất từ cộng đồng',
    'requests.subtitle': 'Các đề xuất và góp ý đã được duyệt từ người dùng Claudemy.',
    'requests.empty.title': 'Chưa có đề xuất nào được duyệt',
    'requests.empty.body': 'Quay lại sau, hoặc gửi đề xuất đầu tiên của bạn.',
    'requests.empty.cta': 'Gửi đề xuất',
    'requests.refresh': 'Làm mới',
    'requests.error': 'Lỗi tải dữ liệu, thử lại sau.',
    'requests.loading': 'Đang tải...',
    'requests.filter.kind.all': 'Tất cả',
    'requests.filter.kind.request': 'Đề xuất',
    'requests.filter.kind.feedback': 'Góp ý',
    'requests.filter.target.all': 'Tất cả',
    'requests.filter.target.module': 'Module',
    'requests.filter.target.course': 'Khoá',
    'requests.filter.target.lesson': 'Bài',
    'requests.filter.target.doc': 'Doc',
    'requests.sort.new': 'Mới nhất',
    'requests.sort.top': 'Phản hồi nhiều',
    'requests.card.upvote': 'Vote trên GitHub',
    'requests.card.viewIssue': 'Xem chi tiết',
  },
  en: {
    'header.tab.request': 'Request',
    'header.tab.feedback': 'Feedback',
    'header.tab.community': 'Community',

    'request.title': 'Request a new course',
    'request.subtitle': 'Got a module or course you want on Claudemy? Send it below.',
    'request.field.kind': 'Request type',
    'request.field.title': 'Title',
    'request.field.title.help': '3–120 chars, short summary',
    'request.field.description': 'Why',
    'request.field.description.help': 'What do you want to learn? For whom? Why does it matter?',
    'request.field.email': 'Email (optional)',
    'request.field.email.help': 'So we can update you',
    'request.kind.module': 'Module (chapter in a course)',
    'request.kind.course': 'Full course',
    'request.submit': 'Send request',
    'request.submit.loading': 'Sending...',

    'feedback.title': 'Feedback / Report',
    'feedback.subtitle': 'Thanks for helping make Claudemy better.',
    'feedback.context': 'About:',
    'feedback.field.message': 'Your feedback',
    'feedback.field.message.help': 'Typos, bugs, ideas... be as specific as you can',
    'feedback.field.email': 'Email (optional)',
    'feedback.field.email.help': 'So we can follow up',
    'feedback.submit': 'Send feedback',
    'feedback.submit.loading': 'Sending...',

    'success.title': 'Thanks!',
    'success.body.request': 'Request received. Our team will review and respond via GitHub.',
    'success.body.feedback': 'Feedback received. Our team will review soon.',
    'success.viewIssue': 'View issue',
    'success.again': 'Send another',

    'error.email_required_check': 'Invalid email',
    'error.turnstile': 'Please verify you are not a bot and try again.',
    'error.rate_limited': 'Too many submissions, try again in 1 hour.',
    'error.invalid_input': 'Invalid data. Please check your fields.',
    'error.network': 'Network error, check connection and retry.',
    'error.internal': 'System error, try again later.',
    'error.turnstile_pending': 'Please complete the verification before submitting.',

    'min': 'At least {n} chars',
    'max': 'At most {n} chars',

    'requests.title': 'Community requests',
    'requests.subtitle': 'Approved requests and feedback from Claudemy users.',
    'requests.empty.title': 'No approved items yet',
    'requests.empty.body': 'Check back later, or be the first to send a request.',
    'requests.empty.cta': 'Send a request',
    'requests.refresh': 'Refresh',
    'requests.error': 'Failed to load. Try again later.',
    'requests.loading': 'Loading...',
    'requests.filter.kind.all': 'All',
    'requests.filter.kind.request': 'Requests',
    'requests.filter.kind.feedback': 'Feedback',
    'requests.filter.target.all': 'All',
    'requests.filter.target.module': 'Module',
    'requests.filter.target.course': 'Course',
    'requests.filter.target.lesson': 'Lesson',
    'requests.filter.target.doc': 'Doc',
    'requests.sort.new': 'Newest',
    'requests.sort.top': 'Most reactions',
    'requests.card.upvote': 'Vote on GitHub',
    'requests.card.viewIssue': 'View details',
  },
} as const

export type MessageKey = keyof (typeof messages)['vi']

export function detectLang(searchParams?: URLSearchParams): Lang {
  const fromQuery = searchParams?.get('lang')
  if (fromQuery === 'vi' || fromQuery === 'en') return fromQuery
  if (typeof navigator !== 'undefined' && navigator.language?.toLowerCase().startsWith('vi')) {
    return 'vi'
  }
  return 'vi'
}

export function t(lang: Lang, key: MessageKey, vars?: Record<string, string | number>): string {
  const raw: string = messages[lang]?.[key] ?? key
  if (!vars) return raw
  return Object.entries(vars).reduce<string>(
    (acc, [k, v]) => acc.replaceAll(`{${k}}`, String(v)),
    raw
  )
}
